module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [\n`textfield-${((model.atom || {}).dataType || '')}`\n];\nif(model.disabled){\nadditionalClasses.push('disabled');\n}\nif(typeof(additionalCSSClass) !== 'undefined'){\nadditionalClasses.push(additionalCSSClass);\n}\nif(model.additionalCSSClass) {\nadditionalClasses.push(model.additionalCSSClass);\n}\n// model[model.dataFlag] is used for downwards compatibility (e.g., vbst partnerPropertiesForm will be rendered by server)\nvar value = model.dataFormatted || model[model.dataFlag || '---noDataFlag---'] || (model.config || {}).defaultValue;\n%>\n<div class=\"<%- additionalClasses.join(' ') %>\">\n<input data-field-type=\"text\" type=\"text\" data-field-code=\"<%- model.fieldCode %>\" value=\"<%= value %>\"<%- (model.disabled ? 'disabled=\"disabled\"' : ''); %> placeholder=\"<%= model.placeholder || '' %>\" />\n<%\nif((model.config || {}).keyDownLabel){\n%><label title=\"<%= model.keyDownLabel || '' %>\"><%= model.keyDownLabel || '' %></label><%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/text.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [
`textfield-${((model.atom || {}).dataType || '')}`
];
if(model.disabled){
additionalClasses.push('disabled');
}
if(typeof(additionalCSSClass) !== 'undefined'){
additionalClasses.push(additionalCSSClass);
}
if(model.additionalCSSClass) {
additionalClasses.push(model.additionalCSSClass);
}
// model[model.dataFlag] is used for downwards compatibility (e.g., vbst partnerPropertiesForm will be rendered by server)
var value = model.dataFormatted || model[model.dataFlag || '---noDataFlag---'] || (model.config || {}).defaultValue;

    ; __line = 16
    ; __append("\n<div class=\"")
    ; __line = 17
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<input data-field-type=\"text\" type=\"text\" data-field-code=\"")
    ; __line = 18
    ; __append( model.fieldCode )
    ; __append("\" value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"")
    ; __append( (model.disabled ? 'disabled="disabled"' : '') )
    ; __append(" placeholder=\"")
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\" />\n")
    ; __line = 19
    ; 
if((model.config || {}).keyDownLabel){

    ; __line = 21
    ; __append("<label title=\"")
    ; __append(escapeFn( model.keyDownLabel || '' ))
    ; __append("\">")
    ; __append(escapeFn( model.keyDownLabel || '' ))
    ; __append("</label>")
    ; 
}

    ; __line = 23
    ; __append("\n</div>")
    ; __line = 24
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/text.ejs

}